import { render, staticRenderFns } from "./addApplyRoomDiscount.vue?vue&type=template&id=14d9f07d&scoped=true"
import script from "./addApplyRoomDiscount.vue?vue&type=script&lang=js"
export * from "./addApplyRoomDiscount.vue?vue&type=script&lang=js"
import style0 from "./addApplyRoomDiscount.vue?vue&type=style&index=0&id=14d9f07d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14d9f07d",
  null
  
)

export default component.exports